import { AnalyticsEvent } from "./analyticsEvent";
class EnquiryFormSubmittedEvent extends AnalyticsEvent {
    public hashed_emailAddress: string;
    public hashed_phoneNumber: string;
    public hashed_firstname: string;
    public hashed_lastname: string;
    public street: string;
    public city: string;
    public region: string;
    public postcode: string;
    public country: string;

    constructor(
        hashed_emailAddress: string, 
        hashed_phoneNumber: string, 
        hashed_firstname: string, 
        hashed_lasttname: string,
        street: string,
        city: string,
        region: string,
        postcode: string,
        country: string
    ) {
        super();
        this.hashed_emailAddress = hashed_emailAddress;
        this.hashed_phoneNumber = hashed_phoneNumber;
        this.hashed_firstname = hashed_firstname;
        this.hashed_lastname = hashed_lasttname;
        this.street = street;
        this.city = city;
        this.region = region;
        this.postcode = postcode;
        this.country = country;

        
    }
}

export { EnquiryFormSubmittedEvent }